export default function validate(values) {
  let errors = {};
  if (!values.email) {
    errors.email = 'O campo E-mail é obrigatório.';
  } else if (!/\S+@\S+\.\S+/.test(values.email)) {
    errors.email = 'E-mail inválido.';
  }
  return errors;
};